import { useState } from "react";
import HttpServices from "src/services/httpService";
import { integrateModuleURL } from "src/services/urlService";
import { useToaster } from "src/utils/toaster/toasterContext";
import BlueskyAuthorizationModal from "./blueskyAuthorizationModal";
import { useTranslation } from "react-i18next";
import { useResellerLimitDialog } from 'src/components/reseller-limit-context/resellerLimitContext';
import { CommonHelper } from "src/utils/commonHelper";

const BlueskyIntegration = ({ handleClose }) => {
  const { t: translate } = useTranslation();
  const { showResellerLimitDialog } = useResellerLimitDialog();

  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [isLoadingOn, setLoadingOn] = useState(false);

  const { showToast } = useToaster();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'identifier') {
      setIdentifier(value);
    } else if (name === 'password') {
      setPassword(value);
    }
  };

  const blueskyIntegrationSuccessCallback = (data, message) => {
    setLoadingOn(false);
    CommonHelper.EnsureConversionFactorFlag(CommonHelper.ConversionFlagList.FIRST_SOCIAL_ACCOUNT_CONNECTED,"BLUESKY")
    showToast(message, 's');
    handleCloseBluesky();
  };

  const blueskyIntegrationFailureCallback = (message) => {
    setLoadingOn(false);
    if (!showResellerLimitDialog(message)) {
      message && showToast(message, 'e');
    }
    handleCloseBluesky();
  };

  const sendBlueskyCredentialsToServer = () => {
    if (!identifier || !password) {
      showToast(translate("bluesky.enter_all_fields"), 'e');
      return;
    }

    setLoadingOn(true);

    const blueskyForm = {
      identifier: identifier.trim(),
      password: password,
    };

    const postProps = {
      url: integrateModuleURL.blueskyIntegration,   // ← Change this URL in urlService
      body: blueskyForm,
      successCallback: blueskyIntegrationSuccessCallback,
      failureCallback: blueskyIntegrationFailureCallback
    };

    HttpServices.Post(postProps);
  };

  const handleCloseBluesky = () => {
    setAuthorizationModal(false);
    handleClose();
  };

  return (
    isAuthorizationModalOpen && (
      <BlueskyAuthorizationModal
        handleBlueskyConnect={sendBlueskyCredentialsToServer}
        handleClose={handleCloseBluesky}
        handleInputChange={handleInputChange}
        identifier={identifier}
        password={password}
        isLoadingOn={isLoadingOn}
      />
    )
  );
};

export default BlueskyIntegration;